import React, { useState } from "react";
import { Info, ChevronDown } from "lucide-react";

/**
 * Collapsible "How to use this page" instructional banner. Defaults open the first time a
 * user visits a page (persisted per pageKey in localStorage), collapsible afterwards so it
 * doesn't get in the way of experienced staff.
 */
export const PageHelpBanner = ({ pageKey, title = "How to use this page", children }) => {
  const storageKey = `yoko.help.collapsed.${pageKey}`;
  const [open, setOpen] = useState(() => localStorage.getItem(storageKey) !== "true");

  const toggle = () => {
    const next = !open;
    setOpen(next);
    localStorage.setItem(storageKey, String(!next));
  };

  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50 mb-6" data-testid={`page-help-${pageKey}`}>
      <button
        type="button"
        onClick={toggle}
        data-testid={`page-help-toggle-${pageKey}`}
        className="flex w-full items-center justify-between gap-2 px-4 py-3 text-left"
      >
        <span className="flex items-center gap-2 text-sm font-semibold text-amber-900">
          <Info size={16} className="text-amber-600 shrink-0" /> {title}
        </span>
        <ChevronDown size={16} className={`text-amber-500 transition-transform shrink-0 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-4 pb-4 text-sm text-amber-900/90 leading-relaxed space-y-2" data-testid={`page-help-content-${pageKey}`}>
          {children}
        </div>
      )}
    </div>
  );
};
